import script from "./videocallheader.vue?vue&type=script&setup=true&lang=js"
export * from "./videocallheader.vue?vue&type=script&setup=true&lang=js"

import "./videocallheader.vue?vue&type=style&index=0&id=d4c04b3c&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\BrikTokApi\\BrikTokAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4c04b3c"]])

export default __exports__